import { useCallback, useState } from 'react';

const useForceRender = () => {
	const [count, setCount] = useState(0);
	const triggerRender = useCallback(() => {
		setCount(val => val + 1);
	}, []);

	return {
		forced: count,
		triggerRender
	};
};

export default useForceRender;
